import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { AiOutlineEye, AiOutlineEyeInvisible } from "react-icons/ai";
import { Link, useNavigate } from "react-router-dom";
import apiClient from "../../service/Axios";
import { useParams } from "react-router-dom";
const TheiaLogin = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [show, setShow] = useState(false);
  const [error, setError] = useState();
  const navigate = useNavigate();
  const { name } = useParams();

  //onsubmit function
  const onSubmit = async (data) => {
    // const { email, password } = data;
    // console.log(email, password);
    // apiClient
    //   .post("http://192.168.10.138:8003/theia-auth/check-user", data)
    //   .then((res) => {
    //     console.log("res", res?.data?.authenticated);
    //     res?.data?.authenticated == true &&
    //       window.location.replace(
    //         "http://157.245.147.52:3000/#/home/workspace-home"
    //       );
    //     localStorage.setItem("usersTheiaInfo", JSON.stringify(res?.data));
    //   })
    //   .catch((err) => setError(err.response.data.errors.non_field_errors[0]));
    try {
      const { email, password } = data;
      // console.log(email, password);

      const response = await apiClient.post(
        // "http://178.128.82.51:8003/theia-auth/check-user",
        `${process.env.REACT_APP_THEIA_API}/theia-auth/check-user/${name}`,
        data
      );

      if (response?.data?.authenticated === true) {
        window.location.replace(`http://157.245.147.52:3000/#/home/${name}`);
        localStorage.setItem("usersTheiaInfo", JSON.stringify(response?.data));
      } else {
        setError("Authentication failed. Please check your credentials.");
      }
    } catch (error) {
      if (error.response) {
        // console.log(error.response.data);
        setError("Server error. Please try again later.");
      } else {
        console.error("An unexpected error occurred:", error.message);
        setError("An unexpected error occurred. Please try again later.");
      }
    }
  };

  return (
    <div className="flex min-h-full flex-col justify-center px-6 py-14 lg:px-8">
      {/* <p>{name}</p> */}
      <div className="sm:mx-auto sm:w-full sm:max-w-sm p-6 rounded-[7px] border border-gray-200 bg-gray-100 mt-32">
        <form
          className="space-y-6"
          action="#"
          method="POST"
          onSubmit={handleSubmit(onSubmit)}>
          <div className="form-control">
            <label
              htmlFor="email"
              className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
              Email
            </label>
            <input
              type="email"
              id="email"
              name="email"
              className="input input-bordered w-full rounded-[5px] h-10"
              autoComplete="email"
              {...register("email", {
                required: true,
                pattern: /^[\w-.]+@([\w-]+\.)+[\w-]{2,}$/,
              })}
            />
            {errors.email && (
              <span className="text-red-500 text-base mt-1">
                Please enter a valid email address.
              </span>
            )}
          </div>
          <div className="form-control">
            <div className="flex justify-between items-center">
              <label
                htmlFor="password"
                className="block text-sm font-medium leading-6 text-gray-900 mb-0.5">
                Password
              </label>{" "}
              <p className="mt-0.5 flex justify-end mb-0.5">
                <Link
                  to=""
                  className="font-normal text-[14px] text-[#1068BF] hover:text-[#5297dc]">
                  Forgot your password?
                </Link>
              </p>
            </div>
            <div className="relative">
              <input
                type={`${show ? "text" : "password"}`}
                id="password"
                name="password"
                className="input input-bordered w-full rounded-[5px] h-10"
                autoComplete="new-password"
                {...register("password", { required: true, minLength: 4 })}
              />
              {errors.password && (
                <span className="text-red-500 text-base mt-1">
                  Please enter a password.
                </span>
              )}
              {error ? (
                <span className="text-red-500 text-base mt-1">{error}</span>
              ) : (
                ""
              )}
              {show ? (
                <AiOutlineEye
                  className="absolute top-3 right-3 text-xl text-gray-600 cursor-pointer"
                  onClick={() => setShow(!show)}
                />
              ) : (
                <AiOutlineEyeInvisible
                  className="absolute top-3 text-xl right-3 text-gray-400 cursor-pointer"
                  onClick={() => setShow(!show)}
                />
              )}
            </div>
          </div>
          <div>
            <button
              type="submit"
              className="flex w-full justify-center rounded-[5px] bg-[#161B22] px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-[#2a5784]">
              Sign in
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TheiaLogin;
